import positioning from '../positioning/positioning'
import anchor_behaviour_controller from '../anchorbehaviour/anchorbehaviour'
import { getTargetContainers } from '../utility/utility_controller'
import unescape from 'lodash/unescape'
import escape from 'lodash/escape'
import union from 'lodash/union'

var $target = undefined

var i = function () {
	bindOnContentReady()
}

var handleCustomRowHeights = function () {}

var runAfterRowHeightTransition = function (row, duration, callback) {
	if (typeof row._layRowHeightTransitionCleanup === 'function') {
		row._layRowHeightTransitionCleanup()
	}

	var finished = false
	var timeoutId = null
	var cleanup = function () {
		row.removeEventListener('transitionend', handleTransitionEnd)
		if (timeoutId !== null) {
			window.clearTimeout(timeoutId)
		}
		if (row._layRowHeightTransitionCleanup === cleanup) {
			delete row._layRowHeightTransitionCleanup
		}
	}
	var finish = function () {
		if (finished) {
			return
		}
		finished = true
		cleanup()
		callback()
	}
	var handleTransitionEnd = function (event) {
		if (event.target !== row || event.propertyName !== 'height') {
			return
		}
		finish()
	}

	row.addEventListener('transitionend', handleTransitionEnd)
	row._layRowHeightTransitionCleanup = cleanup
	timeoutId = window.setTimeout(finish, Math.max(0, parseInt(duration, 10) || 0) + 100)
}

var getExpandArray = function (expand, $anchorGridParent) {
	var expandArr = []
	if (expand.indexOf(',') === -1) {
		expandArr.push(expand)
	} else if (expand.indexOf(',') !== -1) {
		let temp = expand.split(',')
		for (var i = 0; i < temp.length; i++) {
			expandArr.push(temp[i])
		}
	} else {
		expandArr.push(expand)
	}

	// people might have multiple anchors that expand a row. they have set all of these different anchors to expand the same row
	// then they deleted that row from the gridder. and then they set all these different anchors to expand different rows
	// now we still have the expand id of the old row in the anchor. so we need to check if the row still exists
	// otherwise, it will treat it as if all the anchors expand collapse the same row, so they will all have their replacement texts toggled

	// check if the row still exists
	// if not, remove it from the expandArr

	var tempArr = []
	for (var i = 0; i < expandArr.length; i++) {
		var row = $anchorGridParent.find('.row-id-' + expandArr[i])
		if (row.length > 0) {
			tempArr.push(expandArr[i])
		}
	}
	expandArr = tempArr

	return expandArr
}

var maybeReplaceText = function ($anchor) {
	var text = $anchor.attr('data-replacementtext')

	if (text != '' && text != undefined) {
		var originalText = escape($anchor.html())
		$anchor.html(unescape(text))
		$anchor.attr('data-replacementtext', originalText)
		$anchor.toggleClass('lay-text-replaced')
	}
}

var toggleClass = function ($anchor) {
	$anchor.toggleClass('expand-link-clicked')
}

var bindClicks = function () {
	// need to unbind clicks, cause "bindClicks" can be triggered often
	// because content_ready is triggered on size change between phone and desktop size

	var $anchorGridParent = false
	jQuery(document).off('click', 'a[data-expand]')
	jQuery(document).on('click', 'a[data-expand]', function (e) {
		e.stopPropagation()
		e.preventDefault()
		var $anchor = jQuery(this)
		$anchorGridParent = $anchor.closest('.grid')

		var expand = $anchor.attr('data-expand')
		var timing = $anchor.attr('data-animationtiming')

		if (timing.slice(-1) == ';') {
			timing = timing.substring(0, timing.length - 1)
		}
		var duration = $anchor.attr('data-animation')
		var expandArr = getExpandArray(expand, $anchorGridParent)
		var collapse_other_rows = $anchor.attr('data-collapseotherrows')
		var scrolltoexpandedrow = $anchor.attr('data-scrolltoexpandedrow')

		maybeReplaceText($anchor)
		toggleClass($anchor)

		// alter all other links that also expand/collapse the same row
		for (var i = 0; i < expandArr.length; i++) {
			var expandId = parseInt(expandArr[i], 10)
			// why did we need jQuery isNumeric here?
			if (jQuery.isNumeric(expandId)) {
				jQuery(this)
					.closest('.grid')
					.find('a[data-expand]')
					.not($anchor)
					.each(function () {
						var $anchor2 = jQuery(this)

						var expandIds = $anchor2.attr('data-expand').split(',')
						expandIds = expandIds.map(function (x) {
							return parseInt(x, 10)
						})

						// this may seem overly complicated but is needed if for example:
						// - we have 2 collapsed rows
						// - we have two links. both have a replacement text, and both open/collapse the same 2 rows
						if ($anchor.hasClass('expand-link-clicked')) {
							if (expandIds.includes(expandId) && !$anchor2.hasClass('expand-link-clicked')) {
								maybeReplaceText($anchor2)
								toggleClass($anchor2)
							}
						} else {
							if (expandIds.includes(expandId) && $anchor2.hasClass('expand-link-clicked')) {
								maybeReplaceText($anchor2)
								toggleClass($anchor2)
							}
						}
					})
			}
		}

		var $expandedRow = null

		for (var i = 0; i < expandArr.length; i++) {
			// https://css-tricks.com/using-css-transitions-auto-dimensions/
			var $row = jQuery(this)
				.closest('.grid')
				.find('.row-id-' + expandArr[i])
			if ($row.length > 0) {
				var isCollapsed = $row[0].getAttribute('data-collapsed') === 'true'
				if (isCollapsed) {
					expandRow($row[0], timing, duration)
					$row[0].setAttribute('data-collapsed', 'false')
					$expandedRow = $row
				} else {
					collapseRow($row[0], timing, duration)
				}
			}
		}

		if (scrolltoexpandedrow == 'true' && $expandedRow != null && $expandedRow.length > 0) {
			// do not animate body but only html. this way we prevent a scrolling bug where an upper part of the website would be cut off
			setTimeout(function () {
				var top = $expandedRow.offset().top
				top = anchor_behaviour_controller.addSpaceTop(top)
				if ($anchor.closest('.lay-overlay').length > 0) {
					$anchor.closest('.lay-content').animate(
						{
							scrollTop: top,
						},
						300,
						'easeInOutQuad',
						function () {
							var rowid = $expandedRow.attr('id')
							if (typeof rowid != 'undefined' && rowid != '' && rowid != false) {
								window.location.hash = rowid
							}
						}
					)
				} else if ($anchor.closest('#lay-project-overlay').length > 0) {
					$anchor.closest('#lay-project-overlay').animate(
						{
							scrollTop: top,
						},
						300,
						'easeInOutQuad',
						function () {
							var rowid = $expandedRow.attr('id')
							if (typeof rowid != 'undefined' && rowid != '' && rowid != false) {
								window.location.hash = rowid
							}
						}
					)
				} else {
					jQuery('html').animate(
						{
							scrollTop: top,
						},
						300,
						'easeInOutQuad',
						function () {
							var rowid = $expandedRow.attr('id')
							if (typeof rowid != 'undefined' && rowid != '' && rowid != false) {
								window.location.hash = rowid
							}
						}
					)
				}
			}, duration)
		}

		// collapse other expanded rows
		if (collapse_other_rows == 'true') {
			// get rows that can be collapsed / expanded
			// these are rows that are linked to expand / collapse links
			var collapsibleArr = getUserCollapsibleRows($anchorGridParent)

			for (var index = 0; index < collapsibleArr.length; index++) {
				var rowid = collapsibleArr[index]
				if (expandArr.indexOf(rowid) == -1) {
					var $row = jQuery(this)
						.closest('.grid')
						.find('.row[data-collapsed="false"].row-id-' + rowid)
					if ($row.length > 0) {
						collapseRow($row[0], timing, duration)

						// Find active anchors associated with this id. Reset their replacement
						// text and clicked state independently, because links without a
						// replacement text never receive the lay-text-replaced class.
						jQuery(this)
							.closest('.grid')
							.find('a[href="#expandrow"].expand-link-clicked, a[href="#expandrow"].lay-text-replaced')
							.each(function () {
								var $anchor2 = jQuery(this)
								var expand2 = $anchor2.attr('data-expand')
								var expandArr2 = getExpandArray(expand2, $anchorGridParent)
								if (expandArr2.indexOf(rowid) != -1) {
									if ($anchor2.hasClass('lay-text-replaced')) {
										maybeReplaceText($anchor2)
									}
									$anchor2.removeClass('expand-link-clicked')
								}
							})
					}
				}
			}
		}
	})
}

var getUserCollapsibleRows = function ($anchorGridParent) {
	var targetRows = []
	$anchorGridParent.find('a[href="#expandrow"]').each(function () {
		var expand = jQuery(this).attr('data-expand')
		var arr = getExpandArray(expand, $anchorGridParent)
		targetRows = union(targetRows, arr)
	})
	return targetRows
}

// Collapse all currently expanded rows that are controlled by Expand Row links
// inside a grid. Returns the amount of time callers need to wait before
// measuring anchor positions again. This is used by opt-in menu anchor links so
// their scroll target is calculated after the layout has finished shrinking.
var collapseAllExpandedRows = function ($anchorGridParent) {
	if (!$anchorGridParent || $anchorGridParent.length === 0) {
		return 0
	}

	var maxDuration = 0
	var didCollapse = false
	var $anchors = $anchorGridParent.find('a[data-expand]')

	$anchors.each(function () {
		var $anchor = jQuery(this)
		var expand = $anchor.attr('data-expand')
		if (typeof expand == 'undefined' || expand === '') {
			return
		}

		var timing = $anchor.attr('data-animationtiming') || 'ease'
		if (timing.slice(-1) == ';') {
			timing = timing.substring(0, timing.length - 1)
		}
		var duration = parseInt($anchor.attr('data-animation'), 10)
		if (!jQuery.isNumeric(duration)) {
			duration = 0
		}

		var expandArr = getExpandArray(expand, $anchorGridParent)
		for (var i = 0; i < expandArr.length; i++) {
			var $row = $anchorGridParent.find('.row-id-' + expandArr[i] + '[data-collapsed="false"]')
			if ($row.length > 0) {
				collapseRow($row[0], timing, duration)
				didCollapse = true
				maxDuration = Math.max(maxDuration, duration)
			}
		}
	})

	if (!didCollapse) {
		return 0
	}

	// Restore every matching link to its unclicked label/state. Do this after
	// all rows were processed so links that control multiple rows are reset once.
	$anchors.each(function () {
		var $anchor = jQuery(this)
		if ($anchor.hasClass('expand-link-clicked')) {
			maybeReplaceText($anchor)
			toggleClass($anchor)
		}
	})

	// collapseRow starts its transition across two animation frames. Include
	// that setup time so the next anchor measurement sees the final layout.
	return maxDuration + 34
}

// https://css-tricks.com/using-css-transitions-auto-dimensions/
function collapseRow(row, timing, duration) {
	row.classList.remove('lay-row-expanding')
	jQuery(row).css({
		transition: 'height ' + duration + 'ms' + ' ' + timing + ', min-height ' + duration + 'ms' + ' ' + timing,
	})
	row.classList.add('hide-overflow')
	// get the height of the row's inner content, regardless of its actual size
	var sectionHeight = row.scrollHeight

	// temporarily disable all css transitions
	var rowTransition = row.style.transition
	row.style.transition = ''

	// on the next frame (as soon as the previous style change has taken effect),
	// explicitly set the row's height to its current pixel height, so we
	// aren't transitioning out of 'auto'
	requestAnimationFrame(function () {
		row.style.height = sectionHeight + 'px'
		row.style.transition = rowTransition

		runAfterRowHeightTransition(row, duration, function () {
			window.laytheme.emit('lay_row_collapsed')
		})

		// on the next frame (as soon as the previous style change has taken effect),
		// have the row transition to height: 0
		requestAnimationFrame(function () {
			row.style.height = 0 + 'px'
			if (row.classList.contains('rowcustomheight') || row.classList.contains('_100vh')) {
				// for custom row height
				row.style.minHeight = 0 + 'px'
			}
		})
	})

	// mark the section as "currently collapsed"
	row.setAttribute('data-collapsed', 'true')
}

function expandRow(row, timing, duration) {
	row.classList.add('lay-row-expanding')
	jQuery(row).css({
		transition: 'height ' + duration + 'ms' + ' ' + timing + ', min-height ' + duration + 'ms' + ' ' + timing,
	})
	// get the height of the row's inner content, regardless of its actual size
	var sectionHeight = row.scrollHeight

	row.style.height = sectionHeight + 'px'

	// when the next css transition finishes (which should be the one we just triggered)
	runAfterRowHeightTransition(row, duration, function () {
		if (jQuery(row).attr('data-collapsed') == 'false') {
			// remove "height" from the row's inline styles, so it can return to its initial value
			row.style.height = null
			row.classList.remove('hide-overflow')
			if (row.classList.contains('rowcustomheight') || row.classList.contains('_100vh')) {
				// size custom row heights and 100vh heights
				// 100vh would work without this but we need to size 100vh properly for mobile devices
				positioning.doPositioning()
			}
		}
		requestAnimationFrame(function () {
			row.classList.remove('lay-row-expanding')
			window.laytheme.emit('lay_row_expanded')
		})
	})

	// mark the section as "currently not collapsed"
	row.setAttribute('data-collapsed', 'false')
}

var bindOnContentReady = function () {
	window.laytheme.on('content_ready', function (typeOfContentThatIsReady) {
		$target = undefined
		$target = getTargetContainers(typeOfContentThatIsReady)
		handleCustomRowHeights()
		bindClicks()
	})

	// Also listen to overlayshown event for when navigating between overlays
	window.laytheme.on('overlayshown', function ($newTarget) {
		$target = $newTarget
		handleCustomRowHeights()
		bindClicks()
	})
}

var expand_on_anchorscroll = function () {
	var hash = window.location.hash
	var $el = $target.find(hash)
	if ($el.length > 0) {
		var rowId = -1
		var isCollapsed = false
		if ($el.hasClass('row')) {
			var rowId = getRowIdFromClassList($el[0].classList)
			isCollapsed = $el.attr('data-collapsed') === 'true'
		} else {
			var rowId = getRowIdFromClassList($el.closest('.row')[0].classList)
			isCollapsed = $el.closest('.row').attr('data-collapsed') === 'true'
		}

		// only click the button to show the row / show the row, if the row is collapsed
		if (rowId != -1 && isCollapsed) {
			var clicked = false
			// first, we see if we have a button that expands this row, if yes, then click it!
			$target.find('a[data-expand]').each(function () {
				var expand = jQuery(this).attr('data-expand')
				var $anchorGridParent = jQuery(this).closest('.grid')
				var expandArr = getExpandArray(expand, $anchorGridParent)

				for (var i = 0; i < expandArr.length; i++) {
					if (expandArr[i] == rowId) {
						jQuery(this).trigger('click')
						clicked = true
						break
					}
				}
			})

			if (!clicked) {
				// if there was no button, we just expand the row:
				var $row = $target.find('.row-id-' + rowId)
				if ($row.length > 0) {
					var timing = $row.attr('data-animationtiming')
					var duration = $row.attr('data-animation')
					var isCollapsed = $row[0].getAttribute('data-collapsed') === 'true'
					if (isCollapsed) {
						expandRow($row[0], timing, duration)
						$row[0].setAttribute('data-collapsed', 'false')
					}
				}
			}
		}
	}
}

var getRowIdFromClassList = function (classlist) {
	var array = Array.from(classlist)
	var ix = array.findIndex((x) => x.includes('row-id-'))
	if (ix != -1) {
		var rowId = array[ix].split('-')[2]
		return rowId
	}
}

var expandrow_controller = {
	i: i,
	expand_on_anchorscroll: expand_on_anchorscroll,
	collapseAllExpandedRows: collapseAllExpandedRows,
}

export default expandrow_controller
